<template>
  <div class='color-list'>
    <div class='el-color-picker-wrap' v-for="(item, key) in localValue" :index="key">
      <el-color-picker v-model='localValue[key]' size='small' @change="handleReset($event,key)"/>
      <span class="cell-value-tip">
        {{ key == 'default_color' ? defaultTxt : '' }}
        {{ key == 'checked_color' ? checkTxt : '' }}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      localValue: null,
      initValue:{
        default_color: "#666666",
        checked_color: "#687BF2",
      }
    }
  },
  props: {
    value: {
      type: Object||Array,
      default: ()=>[]
    },
    uuid: {
      type: String,
      default: ''
    },
    defaultTxt:{
      type: String,
      default: '默认色'
    },
    checkTxt:{
      type: String,
      default: '选中色'
    }
  },
  watch: {
    uuid: {
      handler() {
        this.localValue = this.value
      },
      deep: true,
      immediate: true
    },
    localValue: {
      handler(val) {
        this.$emit('input', val)
      },
      deep: true
    }
  },
  methods: {
    handleReset(e,key) {
      if(e) return
      this.$set(this.localValue, key, this.initValue[key])
    }
  }
}
</script>

<style scoped>
.color-list {
  display: flex;
  flex-wrap: wrap;
    margin-top: -10px;
  width: 100%;

  .el-color-picker-wrap {
    width: 33.33%;
    margin-top: 10px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

}
</style>
